import { SharedState } from '$utils/sharedState.svelte';

class StateCirclesBasicInfoOnboardingData extends SharedState<Record<string, string>> {}

export const stateCirclesBasicInfoOnboardingData = new StateCirclesBasicInfoOnboardingData(null);
